var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 379,
    viewBox: "0 0 66 379",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.4482 39.6088L52.4482 338.909L14.5183 372.363L14.5183 6.1543L52.4482 39.6088Z",
    fill: "#22AE68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9023 37.5943L53.9023 340.81L12.2801 378.405L12.2801 -1.81937e-06L53.9023 37.5943ZM50.8814 336.894L50.8814 41.6223L16.7556 12.0839L16.7556 366.433L50.8814 336.894Z",
    fill: "#AA612C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65406e-05 0.057251L0 378.462L12.1958 378.462L12.1958 0.0572515L1.65406e-05 0.057251Z",
    fill: "#E29647"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8809 41.6221L48.1955 44.3074L48.1955 334.097L50.8808 336.894L50.8809 41.6221Z",
    fill: "#E29647"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1955 44.3077L16.7551 17.1189L16.7551 12.084L50.8809 41.6224L48.1955 44.3077Z",
    fill: "#75431E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1955 334.097L16.7551 361.285L16.7551 366.432L50.8809 336.894L48.1955 334.097Z",
    fill: "#75431E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.919 37.6511L53.9189 340.867L65.6672 340.867L65.6672 37.6511L53.919 37.6511Z",
    fill: "#E29647"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6436 311.384L58.0421 317.985L55.4687 317.649L54.9093 317.09L62.6296 309.481L64.6436 311.384Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9727 320.67L61.623 324.475L58.714 325.705L58.3783 324.363L61.623 319.216L63.9727 320.67Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7485 289.566L65.5386 300.195C65.6505 300.978 65.203 301.65 64.4198 301.762L58.1541 302.769C57.3709 302.88 56.6995 302.433 56.5876 301.65L54.7974 291.02C54.6856 290.237 55.1331 289.566 55.9163 289.454L62.182 288.447C62.9652 288.335 63.6366 288.894 63.7485 289.566Z",
    fill: "#FFE499"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4896 299.188C59.049 299.077 59.4966 299.412 59.6084 299.972C59.7203 300.531 59.3847 300.979 58.8252 301.091C58.2658 301.202 57.8182 300.867 57.7063 300.307C57.5945 299.748 58.042 299.188 58.4896 299.188Z",
    fill: "#FFD86E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2873 293.146C62.2943 293.034 63.1894 293.593 63.3013 294.6C63.4132 295.607 62.8538 296.503 61.8468 296.614C60.8398 296.726 59.9447 296.167 59.8328 295.16C59.7209 294.265 60.3922 293.258 61.2873 293.146Z",
    fill: "#FFD86E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2591 291.691C57.8185 291.579 58.2661 291.915 58.378 292.475C58.4899 293.034 58.1543 293.482 57.5948 293.593C57.0354 293.705 56.5878 293.37 56.4759 292.81C56.364 292.363 56.6997 291.803 57.2591 291.691Z",
    fill: "#FFD86E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1607 225.902L58.1537 61.2027C58.1537 60.3076 58.825 59.5244 59.7201 59.5244C60.6152 59.5244 61.3984 60.1957 61.3984 61.0908L60.3915 225.79C60.3915 226.125 60.1677 226.349 59.832 226.349C59.4964 226.461 59.1607 226.237 59.1607 225.902Z",
    fill: "#75431E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackboard);
export default __webpack_public_path__ + "static/media/blackboard.f2821f5dccccbbfbc95bb1453b3549e2.svg";
export { ForwardRef as ReactComponent };